import Vue from 'vue';
import Vuex from 'vuex';
import shop from '@/services/shop';
import { sortBy } from 'lodash';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    all: [],
    productModels: undefined,
    error: undefined,
  },
  getters: {
    productModels: state => state.productModels,
  },
  actions: {
    getProductModels({ commit, state }) {
      if (state.all.length > 0) {
        commit('PRODUCT_MODELS_FETCH_SUCCESS', { products: state.all });
      } else {
        shop.getProducts()
          .then((products) => {
            commit('PRODUCT_MODELS_FETCH_SUCCESS', { products });
          })
          .catch((error) => {
            commit('PRODUCT_MODELS_FETCH_FAILURE', { error });
          });
      }
    },
  },
  mutations: {
    PRODUCT_MODELS_FETCH_SUCCESS(state, { products }) {
      state.all = products;
      const models = [...new Set(products.map(product => product.fields.model))];
      models.map((model) => {
        model.products = products.filter(product => product.fields.model.sys.id === model.sys.id);
        model.products.map((product) => {
          Vue.set(product, 'selectedVariation', product.fields.selectedVariation
            ? product.fields.selectedVariation
            : product.fields.variations[0]);
          return product;
        });
        return model;
      });
      state.productModels = sortBy(models, model => model.fields.slug);
    },
    PRODUCT_MODELS_FETCH_FAILURE(state, { error }) {
      state.error = error;
    },
  },
});
